import React from 'react';
import type { CanvasFrame } from '../types';

interface Props {
  frame: CanvasFrame | null;
  isOverview: boolean;
  pathIndex: number;
  pathLength: number;
}

/**
 * Lichte, NIET-geanimeerde tekstsamenvatting voor de telefoon van de spreker.
 * Bewust geen tweede levende mini-canvas: twee onafhankelijke rAF-cameralussen
 * per sessie is onnodige batterij-/CPU-kost voor een scherm dat vooral tussen
 * knopdrukken door even bekeken wordt.
 */
export default function CanvasStepSummary({ frame, isOverview, pathIndex, pathLength }: Props) {
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900 p-4 text-white">
      {isOverview && <p className="text-sm font-medium text-slate-200">Overzicht</p>}
      {!isOverview && frame && (
        <>
          {frame.eyebrow && <p className="text-xs font-semibold uppercase tracking-wide text-teal-300">{frame.eyebrow}</p>}
          {frame.title && <p className="mt-1 text-lg font-semibold">{frame.title}</p>}
          {frame.subtitle && <p className="mt-1 text-sm text-slate-300">{frame.subtitle}</p>}
          {frame.ref && <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-teal-300">{frame.ref}</p>}
        </>
      )}
      {!isOverview && !frame && <p className="text-sm text-slate-400">Geen frame</p>}
      <p className="mt-2 text-xs text-slate-500">
        {pathLength > 0 ? `Stap ${pathIndex + 1} van ${pathLength}` : ''}
      </p>
    </div>
  );
}
